import request from "@utils/request";
import qs from "qs";

/**
 * 商品分类级联列表
 * @param query
 */
export function fetchCasecade(shopId, pid) {
  return request.get(
    `/goods/category/casecade/${shopId}/${pid || 0}`,
    {},
    { noAuth: true }
  );
}
/**
 * 商品分类列表
 * @param query
 */
export function fetchGoods(shopId, query) {
  return request.post(`/goods/list/${shopId}`, query || {}, { noAuth: true });
}
/**
 * 获取商品
 * @param query
 */
export function getGoods(goodsId) {
  return request.get(`/goods/info/${goodsId}`);
}
/**
 * 绑定商户
 * @param query
 */
export function bindShop(shopId, query) {
  return request.post(`/applet/shop/bind/${shopId}`, query || {});
}
/**
 * 解绑定商户
 * @param query
 */
export function removeBind() {
  return request.post(`/applet/shop/remove/bind`);
}
/**
 * 查询商户的门店列表
 */
export function findShop() {
  return request.get(`/applet/shop/list`);
}
/**
 * 查询顾问列表
 *
 */
export function fetchByShop(shopId) {
  return request.get(`/employee/shop/${shopId}`);
}

/**
 * 查询商户的当日营业额
 * @param shopId
 */
export function getHomeCount(shopId) {
  return request.get(`/applet/shop//home/count/${shopId}`);
}
